export const banner = "/assets/common/banner.png";
